/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_EditorInputs */

const en_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const fr_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditeur`)
};

const de_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const it_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redattore`)
};

const ru_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактор`)
};

const es_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const zh_cn2_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const ja_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディタ`)
};

const hi_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादक`)
};

const pt_pt2_team_manager_role_editor = /** @type {(inputs: Team_Manager_Role_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

/**
* | output |
* | --- |
* | "Editor" |
*
* @param {Team_Manager_Role_EditorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_editor = /** @type {((inputs?: Team_Manager_Role_EditorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_EditorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_role_editor(inputs)
	if (locale === "de") return de_team_manager_role_editor(inputs)
	if (locale === "it") return it_team_manager_role_editor(inputs)
	if (locale === "ru") return ru_team_manager_role_editor(inputs)
	if (locale === "es") return es_team_manager_role_editor(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_role_editor(inputs)
	if (locale === "ja") return ja_team_manager_role_editor(inputs)
	if (locale === "hi") return hi_team_manager_role_editor(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_role_editor(inputs)
	return en_team_manager_role_editor(inputs)
});